"use client"

import Image from "next/image"
import { Button } from "./ui/button"
import Link from "next/link"

const ErrorDisplay = ({errorMessage, statusCode, onReset, isResetting,}) => {
  return (
    <div className="w-full h-screen flex justify-center items-center">
        <div className="w-120 border p-6 rounded-sm shadow-lg shadow-rose-100 border border-rose-100">
            <div className="w-50 px-3 mx-auto">
                <Image src={'/assets/img/logo.png'} width={230} height={45} alt="logo" className="w-full h-auto"/>
            </div>
            <h1 className="text-3xl font-geistSans my-3 font-bold text-red-600 text-center">
              Something went wrong!
            </h1>
            <h2 className="text-xl font-bold text-primary/80 font-poppins text-center mt-4">
              Status Code: {statusCode}
            </h2>
            <p className="font-medium font-poppins text-center text-primary/75 mt-3">
              {errorMessage}
            </p>
             <div className="mt-4 flex justify-between p-4">
              <Button
                className="py-5 px-6 rounded-[3px] bg-rose-600 hover:bg-rose-700"
                onClick={() => onReset()}
              >
                {isResetting ? "Retrying..." : "Try again"}
              </Button>
              <Link
                href={"/"}
                className="font-poppins flex justify-center items-center px-2 text-white font-medium rounded-[3px] bg-green-500 hover:bg-green-600"
              >
                Go To Home
              </Link>
            </div>
        </div>
    </div>
  )
}

export default ErrorDisplay